<template>
  <div>
      <template v-if="isIndex">
        <div>
            <!-- 标题 -->
            <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
            <!-- 搜索框 -->
            <ots-refer
              :selectList="selectList"
              :request-form="selectForm"
              @search="getResult"
            />
            <ots-table-group-new
              :tableHeader="tableHeader"
              :tableOption="tableOption"
              :tableData="tableData"
              :pagination="pagination"
              @changeNum="changeSize"
              @changePage="changePage"
            ></ots-table-group-new>
            <!-- 预览公告 -->
            <ots-custom-dialog :dialog.sync="noticeDialog" :title="currentNotice.title" width="40%">
                <template v-slot:content>
                    <p v-html="currentNotice.content"></p>
                </template>
                <template v-slot:footer>
                    <el-button round type="primary" @click="noticeDialog=false">确定</el-button>
                </template>
            </ots-custom-dialog>
        </div>
      </template>
      <template v-else>
        <router-view />
      </template>
  </div>
</template>

<script>
import { selectNoticeListInfo } from '@/http/modules/student/notice'
import { issueNoticeFn, delNoticeFn } from '@/http/modules/notice/notice'
const timeShortCuts = [
    {
      text: "今天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "昨天",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24);
        picker.$emit("pick", [start, end]);
      },
    },
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit("pick", [start, end]);
      },
    },
]
export default {
  name: 'noticeManagement',
  data () {
    return {
      noticeDialog: false,
      currentNotice: {},
      mainTopBtnList: [
        {
          title: '新增',
          fn: this.addNotice
        }
      ],
      selectList: [
        {
          title: "标题",
          type: "input",
          requestKey: "title",
        },
        {
          title: "有效日期",
          type: "daterange",
          requestKey:"dateRange_validityTime",
          pickerOptions: {
            shortcuts: timeShortCuts
          },
        },
        {
          title: "发布状态",
          type: "select",
          requestKey: "noticeStatus",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "已发布",
              value: "50",
            },
            {
              key: "未发布",
              value: "60",
            },
          ],
        },
        {
          title: "发布人",
          type: "input",
          requestKey: "issuer",
        },
        {
          title: "显示形式",
          type: "select",
          requestKey: "noticeShow",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "列表展示",
              value: "0",
            },
            {
              key: "弹窗显示一次",
              value: "1",
            },
            {
              key: "登录页公告显示",
              value: "3"
            },
          ],
        }
      ],
      selectForm: {
        isFrom: '50',
        page: 1,
        size: 10,
        noticeStatus: '',
        noticeShow: '',
        dateRange_validityTime: [],
        orders: ''
      },
      tableData: [],
      tableHeader: [
        {
          title: "标题",
          prop: "title",
          fixed: 'left',
          align : 'left',
          headerAlign : 'left',
          // width: '200'
        },
        {
          title: "发布人",
          width: "120",
          prop: "issuerName",
          fixed: 'left'
        },
        {
          title: "有效时间",
          formatter: (val) => {
            return `${val.row.validStartDate}-${val.row.validEndDate}`
          },
          fixed: 'left'
        },
        {
          title: "创建时间",
          // width: "120",
          prop: "createTime",
          fixed: 'left'
        },
        {
          title: "创建机构",
          prop: "createOrganization",
          fixed: 'left'
        },
        {
          title: "显示形式",
          // width: "120",
          prop: "noticeShow",
          formatter: (val) => {
            const options = {
              "0": '列表展示',
              "1": '弹窗显示一次',
              "2": '弹窗一直显示',
              "3": '登录页公告显示'
            }
            return options[val.row.noticeShow]
          },
          fixed: 'left'
        },
        {
          title: "发布状态",
          width: "120",
          prop: "noticeStatus",
          formatter: (val) => val.row.noticeStatus == '50' ? '已发布' : '未发布',
          type: 'tag_Z',
          tagColor: (scope) => {
            scope.row.state = scope.row.noticeStatus == '50' ? '已发布' : '未发布'
            const options = {
              '已发布': 'col_green',
              '未发布': 'col_grayQ',
            }
            return options[scope.row.state]
          },
          fixed: 'left'
        },
        {
          title: "已读人数",
          width: "100",
          prop: "readCount",
          formatter: (val) => val.row.noticeShow == 3 ? '' : val.row.readCount,
          fixed: 'left'
        },
        {
          title:"操作",
          type:"buttons",
          btnList:[
            {
              title: (scope) => {
                let { noticeStatus } = scope.row
                if (noticeStatus === "50") {
                  return '取消发布'
                } else {
                  return '编辑'
                }
              },
              click: this.dealNotice
            },
            {
              title:  (scope) => {
                let { noticeStatus } = scope.row
                if (noticeStatus === "60") {
                  return '发布'
                } else {
                  return ''
                }
              },
              click: this.issueStatus
            },
            {
              title: "预览",
              click: this.checkNotice
            },
            {
              title:"删除",
              click: this.deleteNotice
            },
          ]
        }
      ],
      tableOption: {

      },
      pagination: {
        total: 0,
      }
    }
  },
  computed: {
    isIndex () {
      return this.$route.name == 'notice'
    }  
  },
  watch: {
    "selectForm.dateRange_validityTime"(val) {
      if (val && val.length) {
        this.selectForm.validityTime = val.join()
      } else {
        this.selectForm.validityTime = "";
      }
    },
    "$route" () {
      if (this.$route.name == 'notice') {
          this.getResult()
      }
    }
  },
  created () {
    this.getResult()
  },
  methods: {
    addNotice() {
      this.$router.push({
        name: 'addNotice'
      })
    },
    deleteNotice(val) {
      this.$confirm('确定要删除这条公告？', '提示', {
        type: 'warning'
      }).then(() => {
        delNoticeFn({id: val.id}).then(({ code }) => {
          if (code == 1) {
            this.$message.success('删除成功')
            this.getResult()
          }
        })
      }).catch(() => {

      })
    },
    issueStatus(val) {
      
      this.$confirm('确认发布这条公告？', '提示', {
        type: 'warning'
      }).then(() => {
        issueNoticeFn({id: val.id}).then(({ code }) => {
          if (code == 1) {
            this.$message.success('发布成功')
            this.getResult()
          }
        })
      }).catch(() => {

      })
    },
    checkNotice(val) {
      this.currentNotice = val
      this.noticeDialog = true
    },
    cancelStatus(val) {
      delNoticeFn({id: val.id, isFrom: '00'}).then(({ code }) => {
        if (code == 1) {
          this.$message.success('操作成功')
          this.getResult()
        }
      })
    },
    editNotice (val) {
      this.$router.push({
        name: 'editNotice',
        query: {
          id: val.id
        }
      })
    },
    dealNotice (val) {
      const { noticeStatus } = val
      if (noticeStatus == '50') {
        this.cancelStatus(val)
      } else {
        this.editNotice(val)
      }
    },
    getResult() {
      this.selectForm.page = 1
      this.getTableList()
    },

    getTableList() {
      let param = this.mixin_dealParamsWithArray(this.selectForm)
      selectNoticeListInfo(param).then((res) => {
        if (res.code == 1) {
          const { data } = res
          this.tableData = data.records
          this.pagination.total = data.total
        }
      })
    },

    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
  }
}
</script>
<style>

</style>